
import { API_ENDPOINTS } from './api-endpoints';
import { crudFactory } from './curd-factory';
import { HttpClientFront } from './http-client-front';


export const getConcalls = {
  
  ...crudFactory('concall', API_ENDPOINTS),
  get:({ 
    tag,
    ...params 
  }) => {    
    return HttpClientFront.get(`/concall_by_symbol/${tag}`, {
      ...params,      
    });
  },
  home:({...params}) => {    
    return HttpClientFront.get(`/all_concalls`, {
      ...params
    });
  },
};

